import { motion } from "framer-motion";
import { reveal, EASE } from "@/lib/motion";

const PLACES = ["Mariahout", "Lieshout", "Beek en Donk", "Aarle-Rixtel"];

export default function Territory() {
  return (
    <section className="section territory" data-testid="territory">
      <motion.div className="area-copy" {...reveal()}>
        <h2>Dichtbij, in Laarbeek.</h2>
        <p>
          Onze startregio is Laarbeek. Woon je net daarbuiten? Dan kijken we samen wat mogelijk is.
        </p>
        <div className="places">
          {PLACES.map((place, i) => (
            <motion.span
              key={place}
              initial={{ opacity: 0, y: 14 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.4 }}
              transition={{ duration: 0.5, delay: i * 0.07, ease: EASE }}
            >
              {place}
            </motion.span>
          ))}
        </div>
      </motion.div>
      <motion.aside
        className="price-note"
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.65, delay: 0.1, ease: EASE }}
        style={{ backgroundImage: "url(/assets/pattern.webp)", backgroundSize: "cover" }}
        data-testid="price-note"
      >
        <h3>
          Eerst de prijs.
          <br />
          Dan de klus.
        </h3>
        <p>
          Geen twee ruimtes zijn hetzelfde. We stemmen de prijs af op hoeveelheid, bereikbaarheid,
          arbeid, vervoer en afvoer.
        </p>
        <p>Extra werk gebeurt alleen na een nieuwe afspraak.</p>
      </motion.aside>
    </section>
  );
}
